<template src="./templates/index.html" />

<script type="text/ecmascript-6">
'use strict'
import InventoryHubInfoFooter from 'src/pages/inventory-ingestion-hub/components/info-footer/index.vue'
import isEqual from 'lodash/isEqual'
import { EARNINGS_REPORT_DASHBOARD,INVENTORY_INGESTION_HUB } from 'src/utils/constants/app-routes-name'

export default {
  name: 'FouFooter',
  components: {
    InventoryHubInfoFooter
  },
  computed: {
    isSalesReport () {
      return isEqual(this.$route.name, EARNINGS_REPORT_DASHBOARD)
    },
    copyright () {
      return `© ${new Date().getFullYear()} Monotype Imaging Inc.`
    },
    isInventoryHub () {
      return isEqual(this.$route.name, INVENTORY_INGESTION_HUB)
    }
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
